module.exports = __webpack_public_path__ + "img/analysis_menu_tooltip.80555b7f.svg";